import React from "react";
import ReactMarkdown from "react-markdown";

import { SEO } from "../components/SEO";
import SubPage from "../components/SubPage";
import pageData from "../data/getting_started.yaml";
import useWindowSize from "../hooks/useWindowSize";
import App_Store_Icon from "../images/svg/App_Store.svg";
import Google_Play_Icon from "../images/svg/Google_Play.svg";
import * as styles from "../styles/GettingStarted.module.css";

export interface GettingStartedStep {
  title: string;
  desc: string;
  image: any;
  showAppStore?: boolean;
}

export interface GettingStartedProps {}

const AppStoreIcons = () => (
  <div className={styles.app_store_icons_container}>
    <a href="https://play.google.com/store/apps/details?id=com.nexhub">
      <Google_Play_Icon />
    </a>
    <a
      href=""
      onClick={() => {
        alert("Not yet available, sorry");
      }}
    >
      <App_Store_Icon />
    </a>
  </div>
);

const LeftImageStep = ({ data }: { data: GettingStartedStep }) => {
  console.log(data);
  return (
    <div className={styles.step_container}>
      <img
        src={data.image}
        style={{ width: 225, maxWidth: 225, minWidth: 225, maxHeight: 412 }}
      />
      <div className={styles.step_text_container}>
        <h2>{data.title}</h2>
        <ReactMarkdown>{data.desc}</ReactMarkdown>
        {data.showAppStore && <AppStoreIcons />}
      </div>
    </div>
  );
};

const RightImageStep = ({ data }: { data: GettingStartedStep }) => {
  return (
    <div className={styles.step_container}>
      <div className={styles.step_text_container}>
        <h2>{data.title}</h2>
        <ReactMarkdown>{data.desc}</ReactMarkdown>
        {data.showAppStore && <AppStoreIcons />}
      </div>
      <img
        src={data.image}
        style={{ width: 225, maxWidth: 225, minWidth: 225, maxHeight: 412 }}
      />
    </div>
  );
};

const VerticalImageStep = ({ data }: { data: GettingStartedStep }) => {
  return (
    <div
      className={styles.step_container}
      style={{
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <img
        src={data.image}
        style={{ width: 225, maxWidth: 225, minWidth: 225, maxHeight: 412 }}
      />
      <div className={styles.step_text_container}>
        <h2>{data.title}</h2>
        <ReactMarkdown>{data.desc}</ReactMarkdown>
        {data.showAppStore && <AppStoreIcons />}
      </div>
    </div>
  );
};

export default (props: GettingStartedProps) => {
  const { width } = useWindowSize();
  const meta = pageData.seo_tags;
  return (
    <SubPage top={true}>
      <SEO
        title={meta.title}
        description={meta.description}
        image={meta.image}
      />
      <div className={styles.content}>
        <h1>Getting Started with NexID</h1>

        {pageData.steps.map((data: GettingStartedStep, index: number) => {
          return width > 550 ? (
            (index + 1) % 2 === 0 ? (
              <RightImageStep data={data} />
            ) : (
              <LeftImageStep data={data} />
            )
          ) : (
            <VerticalImageStep data={data} />
          );
        })}
      </div>
    </SubPage>
  );
};
